import { createFileRoute } from "@tanstack/react-router";

import { CaseDetailsPage } from "../../pages/cases/case/CaseDetails.page";

export const Route = createFileRoute("/_protected/cases/$caseId")({
  component: CaseDetailsPage,
});
